/*
 * File: EnrollStudentInPeriod.ts
 * Author: Austin Robinson
 * Date Created: 7/23/2023
 * Copyright (c) DrivingDoc 2023
 */
import { AxiosError } from 'axios';
import { createMutation } from 'react-query-kit';

import { ErrorResponse, privateApi } from 'api';

export type EnrollStudentInPeriodParams = {
  coursePeriodId: string;
  studentId: string;
  enrollmentType: 'performance_and_observation' | 'observation_only';
  overrideRestrictions: boolean;
};

export type EnrollStudentInPeriodResult = object;

async function enrollStudentInPeriod(params: EnrollStudentInPeriodParams): Promise<EnrollStudentInPeriodResult> {
  if (params === undefined) {
    return [];
  }

  // make api call
  const result = await privateApi.post('/courses/periods/enrollStudentInPeriod', params);

  // return the data object
  return result.data;
}

const useEnrollStudentInPeriod = createMutation<
  EnrollStudentInPeriodResult,
  EnrollStudentInPeriodParams,
  AxiosError<ErrorResponse>
>({
  mutationFn: async (variables: EnrollStudentInPeriodParams) => enrollStudentInPeriod(variables),
});

export { enrollStudentInPeriod, useEnrollStudentInPeriod };
